var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _ from 'lodash';
import { DebugEnv } from './debugEnv';
import { getWithoutHeader } from './req';
import { getSSOUrl, getUa, isDev, getBrowser } from './system';
import { getInfo, queryString, queryStringify } from './utils';
var _a = getUa(), isWeixinMini = _a.isWeixinMini, isWeixinMiniPc = _a.isWeixinMiniPc, isWeixin = _a.isWeixin;
var SDKProtocol = /* @__PURE__ */ (function () {
    function SDKProtocol() {
        var _this = this;
        this.getSSO = function () { return __awaiter(_this, void 0, void 0, function () {
            var ssoUrl, res, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.uid)
                            return [2 /*return*/];
                        ssoUrl = window.IM.ssoUrl;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 6, , 7]);
                        if (!(!this.is_client && (ssoUrl || DebugEnv.isAuth))) return [3 /*break*/, 4];
                        return [4 /*yield*/, getWithoutHeader(ssoUrl || getSSOUrl())];
                    case 2:
                        res = _b.sent();
                        this.setU(res.data.d);
                        return [4 /*yield*/, Promise.resolve()];
                    case 3: return [2 /*return*/, _b.sent()];
                    case 4: return [4 /*yield*/, Promise.resolve()];
                    case 5: return [2 /*return*/, _b.sent()];
                    case 6:
                        _a = _b.sent();
                        return [2 /*return*/, Promise.resolve()];
                    case 7: return [2 /*return*/];
                }
            });
        }); };
        this.openFormView = function (_a) {
            var _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.token, token = _c === void 0 ? '' : _c, sess_id = _a.sess_id;
            var _d = window.location, search = _d.search, hostname = _d.hostname, origin = _d.origin;
            var _e = _this.getState(), platform = _e.platform, game_key = _e.game_key;
            var query = queryStringify(__assign(__assign({}, queryString(search)), { sess_id: sess_id || '', type: type, form_token: token }));
            return _this.openNewWindow("".concat(isDev ? "http://".concat(hostname, ":3002") : origin, "/chat/form/").concat(platform, "/").concat(game_key, "?").concat(query), '表单收集', '/pages/commonUrl/index');
        };
        this.openFormProgress = function (_a) {
            var token = _a.token;
            var _b = window.location, hostname = _b.hostname, origin = _b.origin, search = _b.search;
            var _c = _this.getState(), platform = _c.platform, game_key = _c.game_key;
            var query = queryStringify(__assign(__assign({}, queryString(search)), { form_token: token }));
            return _this.openNewWindow("".concat(isDev ? "http://".concat(hostname, ":3002") : origin, "/chat/form/progress/").concat(platform, "/").concat(game_key, "?").concat(query), '反馈进度', '/pages/commonUrl/index');
        };
        this.openFormDetail = function (_a) {
            var token = _a.token, id = _a.id, historyPush = _a.historyPush;
            var _b = window.location, origin = _b.origin, hostname = _b.hostname, search = _b.search;
            var _c = _this.getState(), platform = _c.platform, game_key = _c.game_key;
            var query = queryStringify(__assign(__assign({}, queryString(search)), { form_token: token, id: id }));
            var base = "".concat(isDev ? "http://".concat(hostname, ":3002") : origin, "/chat/form");
            var path = "/detail/".concat(platform, "/").concat(game_key, "?").concat(query);
            if (historyPush) {
                historyPush(path);
                return -2;
            }
            return _this.openNewWindow(base + path, '反馈详情', '/pages/commonUrl/index');
        };
        this.openIM = function () {
            var _a = window.location, origin = _a.origin, hostname = _a.hostname, search = _a.search;
            var _b = _this.getState(), platform = _b.platform, game_key = _b.game_key;
            var query = queryStringify(_.omit(queryString(search), 'type', 'token', 'sess_id'));
            var base = "".concat(isDev ? "http://".concat(hostname, ":3000") : origin);
            var path = "/chat/im/".concat(platform, "/").concat(game_key, "?").concat(query);
            return _this.openNewWindow(base + path, '在线客服', '/pages/commonUrl/index');
        };
        var info = getInfo();
        this.is_vip = false;
        this.searchParams = info.searchParams;
        this.platform = info.platform;
        this.game_key = info.game_key;
        this.uid = info.uid;
        this.u = info.u;
        this.token = info.token;
        this.t = info.t;
        this.i = info.i;
        this.v = info.v;
        this.flag = info.flag;
        this.safe_area_inset_bottom = info.safe_area_inset_bottom;
        this.is_support_file = info.is_support_file;
        this.show_upload_video_btn = info.show_upload_video_btn;
        this.show_back_im_btn = info.show_back_im_btn;
        this.show_right_sidebar = info.show_right_sidebar;
        this.is_client = info.is_client;
        this.runtime = info.runtime;
        this.channel = info.channel;
        this.client_ua = window.navigator.userAgent;
        this.is_mini = isWeixinMini || isWeixinMiniPc;
        // 消息折叠：默认 true；IE（含 IE11，见 getBrowser）为 false
        this.support_msg_collapse = !/MSIE/i.test(getBrowser());
    }
    SDKProtocol.prototype.setU = function (token) {
        this.u = token;
        window.IM.u = token;
    };
    SDKProtocol.prototype.setVip = function (bol) {
        this.is_vip = bol;
    };
    SDKProtocol.prototype.setSuport = function (bol) {
        this.is_support_file = bol;
    };
    SDKProtocol.prototype.setSupportMsgCollapse = function (bol) {
        this.support_msg_collapse = bol;
    };
    SDKProtocol.prototype.setShowUploadVideoBtn = function (bol) {
        this.show_upload_video_btn = bol;
    };
    SDKProtocol.prototype.setShowBackImBtn = function (bol) {
        this.show_back_im_btn = bol;
    };
    SDKProtocol.prototype.setShowRightSidebar = function (bol) {
        this.show_right_sidebar = bol;
    };
    SDKProtocol.prototype.getState = function () {
        return {
            is_vip: this.is_vip,
            is_client: this.is_client,
            is_mini: this.is_mini,
            client_ua: this.client_ua,
            safe_area_inset_bottom: this.safe_area_inset_bottom,
            token: this.token || null,
            u: this.u || null,
            t: this.t || null,
            i: this.i || null,
            v: this.v || null,
            flag: this.flag || null,
            platform: this.platform,
            game_key: this.game_key,
            runtime: this.runtime,
            is_support_file: this.is_support_file,
            show_upload_video_btn: this.show_upload_video_btn,
            show_back_im_btn: this.show_back_im_btn,
            show_right_sidebar: this.show_right_sidebar,
            support_msg_collapse: this.support_msg_collapse
        };
    };
    SDKProtocol.prototype.DomClick = function (event) {
        var _this = this;
        var _a;
        var localName = event.target.localName;
        var swiper = {
            // a标签在客户端内打开情况
            a: function () { return _this.clickAnchor(event); },
            default: function () { }
        };
        return ((_a = swiper === null || swiper === void 0 ? void 0 : swiper[localName]) === null || _a === void 0 ? void 0 : _a.call(swiper)) || swiper.default();
    };
    SDKProtocol.prototype.downloadFile = function (type, event, down_url, file_url, file_name, file_ext) {
        var _a;
        if (isWeixin) {
            return -2;
        }
        if (!this.is_client)
            return -1;
        if (type === 'dom') {
            event.preventDefault();
        }
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.downloadFile)) {
            return 0;
        }
        window.IMBridge.downloadFile(down_url, file_url, file_name, file_ext);
        return 1;
    };
    SDKProtocol.prototype.clickAnchor = function (event, isCurrent) {
        var _a;
        if (isCurrent === void 0) { isCurrent = false; }
        var url = isCurrent ? event.currentTarget.href : event.target.href;
        if (!this.is_client)
            return -1;
        event.preventDefault();
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.clickAnchor)) {
            return 0;
        }
        window.IMBridge.clickAnchor(url);
        return 1;
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.syncStage = function (stage) {
        var _a;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.syncStage)) {
            return 0;
        }
        window.IMBridge.syncStage(stage);
        // eslint-disable-next-line no-console
        console.log('[IMBridge] 客服阶段变化：', stage);
        return 1;
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.syncSession = function (data) {
        var _a;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.syncSession)) {
            return 0;
        }
        window.IMBridge.syncSession(data);
        // eslint-disable-next-line no-console
        console.log('[IMBridge] 客服会话信息：', data);
        return 1;
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.mountToolbarSlot = function (container) {
        var _a, _b;
        try {
            return (_b = (_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.mountToolbarSlot) === null || _b === void 0 ? void 0 : _b.call(_a, container);
        }
        catch (error) {
            console.error('[IMBridge] 工具栏插槽挂载失败：', error);
            return undefined;
        }
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.renderCustomMessage = function (message) {
        var _a, _b;
        try {
            return ((_b = (_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.renderCustomMessage) === null || _b === void 0 ? void 0 : _b.call(_a, message)) || null;
        }
        catch (error) {
            console.error("[IMBridge] \u81EA\u5B9A\u4E49\u6D88\u606F\u6E32\u67D3\u5931\u8D25\uFF1A".concat(message.type, "@").concat(message.version), error);
            return null;
        }
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.closeWebView = function () {
        var _a;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.closeWebView)) {
            return 0;
        }
        window.IMBridge.closeWebView();
        return 1;
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.goBackWebView = function () {
        var _a;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.goBackWebView)) {
            return 0;
        }
        window.IMBridge.goBackWebView();
        return 1;
    };
    SDKProtocol.prototype.openNewWindow = function (url, title, mini_url) {
        var _a;
        if (!this.is_client) {
            setTimeout(function () {
                window.open(url, '_blank');
            }, 0);
            return -1;
        }
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.openNewWindow)) {
            return 0;
        }
        window.IMBridge.openNewWindow(url, title, mini_url);
        return 1;
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.exitConfirm = function (function_name) {
        var _a;
        if (!this.is_client)
            return -1;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.exitConfirm)) {
            return 0;
        }
        window.IMBridge.exitConfirm(function_name);
        return 1;
    };
    SDKProtocol.prototype.beforeChooseImage = function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.is_client)
                    return [2 /*return*/, -1];
                if (!((_a = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _a === void 0 ? void 0 : _a.beforeChooseImage)) {
                    return [2 /*return*/, 0];
                }
                return [2 /*return*/, new Promise(function (res, rej) {
                        var _a, _b;
                        (_b = (_a = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _a === void 0 ? void 0 : _a.beforeChooseImage) === null || _b === void 0 ? void 0 : _b.call(_a, params, function (result) { return res(result); }, function (error) { return rej(error); });
                    })];
            });
        });
    };
    SDKProtocol.prototype.beforeChooseVideo = function (params) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                if (!this.is_client)
                    return [2 /*return*/, -1];
                if (!((_a = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _a === void 0 ? void 0 : _a.beforeChooseVideo)) {
                    return [2 /*return*/, 0];
                }
                return [2 /*return*/, new Promise(function (res, rej) {
                        var _a, _b;
                        (_b = (_a = window === null || window === void 0 ? void 0 : window.IMBridge) === null || _a === void 0 ? void 0 : _a.beforeChooseVideo) === null || _b === void 0 ? void 0 : _b.call(_a, params, function (result) { return res(result); }, function (error) { return rej(error); });
                    })];
            });
        });
    };
    // eslint-disable-next-line class-methods-use-this
    SDKProtocol.prototype.resizeUpdate = function () {
        window.lib.flexible.refreshRem();
    };
    SDKProtocol.prototype.openImgViewer = function (list, index) {
        var _a;
        if (!((_a = window.IMBridge) === null || _a === void 0 ? void 0 : _a.openImgViewer)) {
            return 0;
        }
        window.IMBridge.openImgViewer(list, index);
        return 1;
    };
    return SDKProtocol;
}());
export { SDKProtocol };
